import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { isFromYjs } from './auto-joiner-extension';

/**
 * A view that is not editable changes the document only with what Yjs
 * delivers. Any other doc change — a normaliser's appended transaction
 * included, since those pass through filterTransaction too — is dropped, so
 * a read-only client never writes to the shared doc.
 */
export const ReadOnlyGuard = Extension.create({
  name: 'readOnlyGuard',

  addProseMirrorPlugins() {
    const editor = this.editor;
    return [
      new Plugin({
        key: new PluginKey('readOnlyGuard'),
        filterTransaction: (tr) => !tr.docChanged || editor.isEditable || isFromYjs(tr),
      }),
    ];
  },
});
